import styled from 'styled-components';

const PublishFilesWrapper = styled.div`

  .header-publish-files-wrapper {
    align-items: center;
    font-size: 18px;
    color: #000;
    .file-name {
      width: 40%;
      margin: 0;
    }
    .file-type, .file-added-at, .file-download-link, .file-publish {
      width: 15%;
      margin: 0;
    }
  }
  .file-wrapper {
    width: 100%;
    .file-name {
      width: 40%;
      margin: 0;
    }
    .file-type, .file-added-at, .download-wrapper {
      width: 15%;
      margin: 0;
    }
    .download-wrapper {
      padding-left: 30px;
    }
    .file-publish {
      width: auto;
    }
    .file-download-link {
      font-size: 24px;
    }
  }

`;

export default PublishFilesWrapper;


// WEBPACK FOOTER //
// ./src/components/IC/PublishFiles/PublishFiles.style.js